import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withKeys as _withKeys, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a86eeb5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "finance-dashboard" }
const _hoisted_2 = { class: "dashboard-intro" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dashboard-intro__whatsapp",
  href: "https://wa.me/5511954361875",
  target: "_blank",
  rel: "noopener noreferrer",
  "aria-label": "Conversar com a IA no WhatsApp para anotar suas finanças (abre em nova aba)",
  title: "Anotar com a IA no WhatsApp"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-whatsapp-logo",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_4 = { class: "dashboard-intro__actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "dashboard-feedback dashboard-feedback--error",
  role: "alert"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-warning-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Não foi possível atualizar os dados.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", {
  class: "summary-card summary-card--loading",
  "aria-label": "Carregando resumo financeiro"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--label" }),
  /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--value" }),
  /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--chip" })
], -1))
const _hoisted_10 = {
  class: "quick-actions quick-actions--loading",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "summary-card__topline" }
const _hoisted_12 = { id: "month-summary-title" }
const _hoisted_13 = { class: "summary-card__filter summary-card__filter--top" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Visualizar", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "cashflow" }, "Entradas e saídas", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "total" }, "Cenário: gastos + previsões", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "expenses" }, "Gastos", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "fixed" }, "Recorrentes", -1))
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "summary-card__flow",
  "aria-label": "Entradas e saídas do mês"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Entradas", -1))
const _hoisted_22 = { class: "summary-card__flow-value summary-card__flow-value--income" }
const _hoisted_23 = { class: "summary-card__flow-outflow" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Saídas", -1))
const _hoisted_25 = {
  key: 1,
  class: "summary-card__value"
}
const _hoisted_26 = {
  key: 2,
  class: "summary-card__balance"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Saldo do mês"),
  /*#__PURE__*/_createElementVNode("span", null, "Entradas menos saídas")
], -1))
const _hoisted_28 = {
  class: "quick-actions",
  "aria-label": "Ações rápidas"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "quick-action__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-plus",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Novo gasto", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "quick-action__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-receipt",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lançamentos", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "quick-action__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-calendar-check",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Recorrentes", -1))
const _hoisted_35 = { class: "dashboard-columns" }
const _hoisted_36 = {
  class: "dashboard-panel category-panel",
  "aria-labelledby": "category-title"
}
const _hoisted_37 = { class: "panel-heading" }
const _hoisted_38 = { class: "panel-heading__eyebrow" }
const _hoisted_39 = { id: "category-title" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ver tudo", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_42 = { class: "category-list mt-30" }
const _hoisted_43 = ["aria-label", "onClick", "onKeydown"]
const _hoisted_44 = { class: "category-item__content" }
const _hoisted_45 = { class: "category-item__name" }
const _hoisted_46 = { class: "category-item__title" }
const _hoisted_47 = {
  key: 0,
  class: "category-item__fixed-badge"
}
const _hoisted_48 = { class: "category-item__meta" }
const _hoisted_49 = { class: "category-item__value" }
const _hoisted_50 = {
  class: "category-item__track",
  "aria-hidden": "true"
}
const _hoisted_51 = {
  key: 0,
  class: "category-pagination",
  "aria-label": "Paginação das categorias"
}
const _hoisted_52 = { class: "category-pagination__summary" }
const _hoisted_53 = { class: "category-pagination__actions" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["aria-current", "onClick"]
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "category-pagination__mobile" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "empty-state__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-chart-donut",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_66 = {
  class: "period-grid",
  "aria-label": "Outros períodos"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "period-card__icon period-card__icon--week" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-calendar-blank",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "period-card__icon period-card__icon--days" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-chart-line-up",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_69 = {
  class: "dashboard-panel recurring-panel",
  "aria-labelledby": "recurring-title"
}
const _hoisted_70 = { class: "panel-heading" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "panel-heading__eyebrow" }, "Compromissos"),
  /*#__PURE__*/_createElementVNode("h2", { id: "recurring-title" }, "Gastos recorrentes")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerenciar", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_74 = { class: "recurring-summary mt-30" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Previsto no período", -1))
const _hoisted_76 = { class: "recurring-list" }
const _hoisted_77 = { class: "recurring-item__date" }
const _hoisted_78 = { class: "recurring-item__name" }
const _hoisted_79 = { class: "recurring-item__value" }
const _hoisted_80 = {
  key: 0,
  class: "category-pagination recurring-pagination",
  "aria-label": "Paginação dos gastos recorrentes"
}
const _hoisted_81 = { class: "category-pagination__summary" }
const _hoisted_82 = { class: "category-pagination__actions" }
const _hoisted_83 = ["disabled"]
const _hoisted_84 = ["aria-current", "onClick"]
const _hoisted_85 = ["disabled"]
const _hoisted_86 = { class: "category-pagination__mobile" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = ["disabled"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = {
  key: 1,
  class: "recurring-empty"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nenhum gasto recorrente cadastrado.", -1))
const _hoisted_95 = {
  key: 3,
  class: "category-detail",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "category-detail-title"
}
const _hoisted_96 = { class: "category-detail__content" }
const _hoisted_97 = { class: "category-detail__sticky-header" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "category-detail__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_99 = { class: "category-detail__header" }
const _hoisted_100 = { class: "panel-heading__eyebrow" }
const _hoisted_101 = { id: "category-detail-title" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = { class: "category-detail__summary" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Total exibido", -1))
const _hoisted_106 = { class: "category-detail__projection" }
const _hoisted_107 = {
  key: 0,
  class: "category-detail__loading",
  role: "status"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-spinner-gap is-spinning",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carregando os gastos...", -1))
const _hoisted_110 = [
  _hoisted_108,
  _hoisted_109
]
const _hoisted_111 = {
  key: 1,
  class: "category-detail__error",
  role: "alert"
}
const _hoisted_112 = {
  key: 2,
  class: "category-detail__list"
}
const _hoisted_113 = ["role", "tabindex", "onClick", "onKeydown"]
const _hoisted_114 = {
  key: 3,
  class: "category-detail__empty"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-receipt",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nenhum item encontrado", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há detalhes disponíveis para esta categoria no período.", -1))
const _hoisted_118 = [
  _hoisted_115,
  _hoisted_116,
  _hoisted_117
]
const _hoisted_119 = {
  key: 4,
  class: "category-detail",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "period-detail-title"
}
const _hoisted_120 = { class: "category-detail__content" }
const _hoisted_121 = { class: "category-detail__sticky-header" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "category-detail__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_123 = { class: "category-detail__header" }
const _hoisted_124 = { class: "panel-heading__eyebrow" }
const _hoisted_125 = { id: "period-detail-title" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_127 = [
  _hoisted_126
]
const _hoisted_128 = { class: "category-detail__summary" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "period-detail__marker",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Total exibido", -1))
const _hoisted_131 = {
  key: 0,
  class: "category-detail__loading",
  role: "status"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-spinner-gap is-spinning",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carregando os gastos...", -1))
const _hoisted_134 = [
  _hoisted_132,
  _hoisted_133
]
const _hoisted_135 = {
  key: 1,
  class: "category-detail__error",
  role: "alert"
}
const _hoisted_136 = {
  key: 2,
  class: "category-detail__list"
}
const _hoisted_137 = ["role", "tabindex", "onClick", "onKeydown"]
const _hoisted_138 = {
  key: 3,
  class: "category-detail__empty"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-receipt",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nenhum item encontrado", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há detalhes disponíveis para este período.", -1))
const _hoisted_142 = [
  _hoisted_139,
  _hoisted_140,
  _hoisted_141
]
const _hoisted_143 = {
  key: 5,
  class: "transaction-detail",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "transaction-detail-title"
}
const _hoisted_144 = { class: "transaction-detail__content" }
const _hoisted_145 = { class: "transaction-detail__sticky-header" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "transaction-detail__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_147 = { class: "transaction-detail__header" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "panel-heading__eyebrow" }, "Detalhes"),
  /*#__PURE__*/_createElementVNode("h2", { id: "transaction-detail-title" }, "Lançamento")
], -1))
const _hoisted_149 = { class: "transaction-detail__header-actions" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-pencil-simple",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editar", -1))
const _hoisted_152 = [
  _hoisted_150,
  _hoisted_151
]
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_154 = [
  _hoisted_153
]
const _hoisted_155 = { class: "transaction-detail__amount-field" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor", -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "R$", -1))
const _hoisted_158 = {
  key: 0,
  class: "transaction-detail__form-field"
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Categoria", -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Outros (automático)", -1))
const _hoisted_161 = ["value"]
const _hoisted_162 = { class: "transaction-detail__form-field" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descrição", -1))
const _hoisted_164 = {
  class: "transaction-detail__grid transaction-detail__grid--metadata",
  "aria-label": "Informações não editáveis"
}
const _hoisted_165 = { "aria-disabled": "true" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Data e hora", -1))
const _hoisted_167 = { "aria-disabled": "true" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Origem", -1))
const _hoisted_169 = { class: "transaction-detail__edit-actions" }
const _hoisted_170 = ["disabled"]
const _hoisted_171 = ["disabled"]
const _hoisted_172 = {
  key: 0,
  class: "ph ph-check",
  "aria-hidden": "true"
}
const _hoisted_173 = {
  key: 1,
  class: "transaction-detail__feedback",
  role: "alert"
}
const _hoisted_174 = { class: "transaction-detail__grid" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Descrição", -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Categoria", -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Data e hora", -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Origem", -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "ph ph-chat-circle-dots",
      "aria-hidden": "true"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "O que foi dito à IA"),
    /*#__PURE__*/_createElementVNode("small", null, "Mensagem original do lançamento")
  ])
], -1))
const _hoisted_180 = { key: 0 }
const _hoisted_181 = { key: 1 }
const _hoisted_182 = {
  key: 2,
  class: "transaction-detail__recurring"
}
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrows-clockwise",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FinancialPrivacyButton = _resolveComponent("FinancialPrivacyButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MonthlyReportExportCard = _resolveComponent("MonthlyReportExportCard")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FinancialPrivacyButton),
        _createElementVNode("button", {
          class: "refresh-button",
          type: "button",
          disabled: _ctx.loading,
          "aria-label": "Atualizar dados do dashboard",
          title: "Atualizar dados",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["ph ph-arrow-clockwise", { 'is-spinning': _ctx.loading }]),
            "aria-hidden": "true"
          }, null, 2)
        ], 8, _hoisted_5)
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _createElementVNode("div", null, [
            _hoisted_7,
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
          }, "Tentar novamente")
        ]))
      : _createCommentVNode("", true),
    (_ctx.summaryInitializing)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
              return _createElementVNode("span", {
                key: item,
                class: "skeleton skeleton--action"
              })
            }), 64))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("section", {
            class: _normalizeClass(["summary-card", { 'summary-card--cashflow': _ctx.summaryMode === 'cashflow' }]),
            "aria-labelledby": "month-summary-title"
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.monthSummaryTitle), 1),
              _createElementVNode("label", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.summaryMode) = $event)),
                  "aria-label": "Escolher valores exibidos no resumo"
                }, _hoisted_19, 512), [
                  [_vModelSelect, _ctx.summaryMode]
                ])
              ])
            ]),
            (_ctx.summaryMode === 'cashflow')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    _createElementVNode("strong", _hoisted_22, _toDisplayString(_ctx.privateValue(_ctx.currentMonthIncomeValue)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("strong", {
                      class: _normalizeClass(["summary-card__flow-value", _ctx.valuesVisible ? _ctx.currentMonthOutflowClass : 'summary-card__flow-value--outflow'])
                    }, _toDisplayString(_ctx.privateValue(_ctx.currentMonthOutflowValue)), 3)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("strong", _hoisted_25, _toDisplayString(_ctx.privateValue(_ctx.currentMonthValue)), 1)),
            (_ctx.summaryMode === 'cashflow')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("strong", {
                    class: _normalizeClass(_ctx.valuesVisible ? _ctx.currentMonthBalanceClass : 'is-hidden')
                  }, _toDisplayString(_ctx.privateValue(_ctx.currentMonthBalanceValue)), 3)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["summary-card__comparison", _ctx.comparisonClass])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.valuesVisible ? _ctx.comparisonIcon : 'ph ph-eye-slash'),
                "aria-hidden": "true"
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(_ctx.valuesVisible ? _ctx.comparisonText : 'Comparativo oculto'), 1)
            ], 2)
          ], 2),
          _createElementVNode("nav", _hoisted_28, [
            _createVNode(_component_router_link, {
              to: { path: '/financial-management', query: { new: 'expense' } },
              class: "quick-action quick-action--primary"
            }, {
              default: _withCtx(() => [
                _hoisted_29,
                _hoisted_30
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/financial-management",
              class: "quick-action"
            }, {
              default: _withCtx(() => [
                _hoisted_31,
                _hoisted_32
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/recurring-expenses",
              class: "quick-action"
            }, {
              default: _withCtx(() => [
                _hoisted_33,
                _hoisted_34
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("section", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.categoryPanelEyebrow), 1),
                  _createElementVNode("h2", _hoisted_39, _toDisplayString(_ctx.categoryPanelTitle), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: _ctx.categoryDetailsRoute,
                  class: "panel-heading__action"
                }, {
                  default: _withCtx(() => [
                    _hoisted_40,
                    _hoisted_41
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              (_ctx.categoryPreview.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryPreview, (item) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: item.key,
                          class: "category-item",
                          role: "button",
                          tabindex: "0",
                          "aria-label": `Ver gastos de ${item.category}`,
                          onClick: ($event: any) => (_ctx.openCategoryDetails(item)),
                          onKeydown: [
                            _withKeys(($event: any) => (_ctx.openCategoryDetails(item)), ["enter"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.openCategoryDetails(item)), ["prevent"]), ["space"])
                          ]
                        }, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("span", {
                              class: "category-item__marker",
                              style: _normalizeStyle({ backgroundColor: _ctx.categoryColor(item) }),
                              "aria-hidden": "true"
                            }, null, 4),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("strong", null, _toDisplayString(item.category), 1),
                                (_ctx.categoryFixedBadge(item))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.categoryFixedBadge(item)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.categoryItemMeta(item)), 1)
                            ]),
                            _createElementVNode("strong", _hoisted_49, _toDisplayString(_ctx.privateValue(_ctx.money(item.displayTotal))), 1)
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("span", {
                              style: _normalizeStyle({ width: `${_ctx.categoryPercentage(item)}%`, backgroundColor: _ctx.categoryColor(item) })
                            }, null, 4)
                          ])
                        ], 40, _hoisted_43))
                      }), 128))
                    ]),
                    (_ctx.categoryLastPage > 1)
                      ? (_openBlock(), _createElementBlock("nav", _hoisted_51, [
                          _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.categoryPaginationSummary), 1),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("button", {
                              type: "button",
                              disabled: _ctx.categoryPage <= 1,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToCategoryPage(_ctx.categoryPage - 1)))
                            }, "Anterior", 8, _hoisted_54),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryPaginationPages, (page) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: page,
                                type: "button",
                                class: _normalizeClass({ active: page === _ctx.categoryPage }),
                                "aria-current": page === _ctx.categoryPage ? 'page' : undefined,
                                onClick: ($event: any) => (_ctx.goToCategoryPage(page))
                              }, _toDisplayString(page), 11, _hoisted_55))
                            }), 128)),
                            _createElementVNode("button", {
                              type: "button",
                              disabled: _ctx.categoryPage >= _ctx.categoryLastPage,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToCategoryPage(_ctx.categoryPage + 1)))
                            }, "Próxima", 8, _hoisted_56)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("button", {
                              type: "button",
                              "aria-label": "Página anterior",
                              disabled: _ctx.categoryPage <= 1,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToCategoryPage(_ctx.categoryPage - 1)))
                            }, _hoisted_60, 8, _hoisted_58),
                            _createElementVNode("span", null, "Página " + _toDisplayString(_ctx.categoryPage) + " de " + _toDisplayString(_ctx.categoryLastPage), 1),
                            _createElementVNode("button", {
                              type: "button",
                              "aria-label": "Próxima página",
                              disabled: _ctx.categoryPage >= _ctx.categoryLastPage,
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToCategoryPage(_ctx.categoryPage + 1)))
                            }, _hoisted_63, 8, _hoisted_61)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.categoryEmptyTitle), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.categoryEmptyDescription), 1),
                    _createVNode(_component_router_link, { to: _ctx.categoryEmptyRoute }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.categoryEmptyAction), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
            ]),
            _createElementVNode("section", _hoisted_66, [
              _createElementVNode("article", {
                class: "period-card",
                role: "button",
                tabindex: "0",
                "aria-label": "Ver gastos desta semana",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openPeriodDetails('week'))),
                onKeydown: [
                  _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.openPeriodDetails('week')), ["enter"])),
                  _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (_ctx.openPeriodDetails('week')), ["prevent"]), ["space"]))
                ]
              }, [
                _hoisted_67,
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.currentWeekTitle), 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.currentWeekValue)), 1)
                ])
              ], 32),
              _createElementVNode("article", {
                class: "period-card",
                role: "button",
                tabindex: "0",
                "aria-label": "Ver gastos dos últimos 15 dias",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openPeriodDetails('last15'))),
                onKeydown: [
                  _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.openPeriodDetails('last15')), ["enter"])),
                  _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => (_ctx.openPeriodDetails('last15')), ["prevent"]), ["space"]))
                ]
              }, [
                _hoisted_68,
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.last15DaysTitle), 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.last15DaysValue)), 1)
                ])
              ], 32)
            ]),
            _createElementVNode("section", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createVNode(_component_router_link, {
                  to: "/recurring-expenses",
                  class: "panel-heading__action"
                }, {
                  default: _withCtx(() => [
                    _hoisted_72,
                    _hoisted_73
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.recurringTotal)), 1)
              ]),
              (_ctx.recurringPreview.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_76, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recurringPreview, (item) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: item.id,
                          class: "recurring-item"
                        }, [
                          _createElementVNode("span", _hoisted_77, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.dueDay(item.next_due_date)), 1),
                            _createElementVNode("small", null, _toDisplayString(_ctx.dueMonth(item.next_due_date)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                            _createElementVNode("span", null, _toDisplayString(item.category?.name || 'Sem categoria'), 1)
                          ]),
                          _createElementVNode("strong", _hoisted_79, _toDisplayString(_ctx.privateValue(_ctx.money(item.amount))), 1)
                        ]))
                      }), 128))
                    ]),
                    (_ctx.recurringLastPage > 1)
                      ? (_openBlock(), _createElementBlock("nav", _hoisted_80, [
                          _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.recurringPaginationSummary), 1),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("button", {
                              type: "button",
                              disabled: _ctx.recurringPage <= 1,
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToRecurringPage(_ctx.recurringPage - 1)))
                            }, "Anterior", 8, _hoisted_83),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recurringPaginationPages, (page) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: page,
                                type: "button",
                                class: _normalizeClass({ active: page === _ctx.recurringPage }),
                                "aria-current": page === _ctx.recurringPage ? 'page' : undefined,
                                onClick: ($event: any) => (_ctx.goToRecurringPage(page))
                              }, _toDisplayString(page), 11, _hoisted_84))
                            }), 128)),
                            _createElementVNode("button", {
                              type: "button",
                              disabled: _ctx.recurringPage >= _ctx.recurringLastPage,
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToRecurringPage(_ctx.recurringPage + 1)))
                            }, "Próxima", 8, _hoisted_85)
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("button", {
                              type: "button",
                              "aria-label": "Página anterior",
                              disabled: _ctx.recurringPage <= 1,
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToRecurringPage(_ctx.recurringPage - 1)))
                            }, _hoisted_89, 8, _hoisted_87),
                            _createElementVNode("span", null, "Página " + _toDisplayString(_ctx.recurringPage) + " de " + _toDisplayString(_ctx.recurringLastPage), 1),
                            _createElementVNode("button", {
                              type: "button",
                              "aria-label": "Próxima página",
                              disabled: _ctx.recurringPage >= _ctx.recurringLastPage,
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goToRecurringPage(_ctx.recurringPage + 1)))
                            }, _hoisted_92, 8, _hoisted_90)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_93, [
                    _hoisted_94,
                    _createVNode(_component_router_link, { to: "/recurring-expenses" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Adicionar recorrente")
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _createVNode(_component_MonthlyReportExportCard)
          ])
        ], 64)),
    (_ctx.selectedCategory)
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createElementVNode("div", {
            class: "category-detail__backdrop",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeCategoryDetails && _ctx.closeCategoryDetails(...args)))
          }),
          _createElementVNode("section", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _hoisted_98,
              _createElementVNode("header", _hoisted_99, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.categoryDetailEyebrow), 1),
                  _createElementVNode("h2", _hoisted_101, _toDisplayString(_ctx.selectedCategory.category), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Fechar detalhes da categoria",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeCategoryDetails && _ctx.closeCategoryDetails(...args)))
                }, _hoisted_103)
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("span", {
                style: _normalizeStyle({ backgroundColor: _ctx.categoryColor(_ctx.selectedCategory) }),
                "aria-hidden": "true"
              }, null, 4),
              _createElementVNode("div", null, [
                _hoisted_105,
                _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.money(_ctx.selectedCategory.displayTotal))), 1),
                _createElementVNode("p", _hoisted_106, [
                  _createTextVNode(" Estimativa em 12 meses: "),
                  _createElementVNode("b", null, _toDisplayString(_ctx.privateValue(_ctx.money(_ctx.selectedCategory.displayTotal * 12))), 1)
                ])
              ])
            ]),
            (_ctx.categoryDetailLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, _hoisted_110))
              : (_ctx.categoryDetailError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.categoryDetailError), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.reloadCategoryDetails && _ctx.reloadCategoryDetails(...args)))
                    }, "Tentar novamente")
                  ]))
                : (_ctx.categoryDetailItems.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryDetailItems, (item) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: item.key,
                          class: _normalizeClass(["category-detail__item", { 'is-clickable': item.transaction }]),
                          role: item.transaction ? 'button' : undefined,
                          tabindex: item.transaction ? 0 : undefined,
                          onClick: ($event: any) => (_ctx.openTransactionDetails(item)),
                          onKeydown: [
                            _withKeys(($event: any) => (_ctx.openTransactionDetails(item)), ["enter"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.openTransactionDetails(item)), ["prevent"]), ["space"])
                          ]
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["category-detail__icon", `is-${item.kind}`])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(item.kind === 'fixed' ? 'ph ph-calendar-check' : 'ph ph-arrow-up-right'),
                              "aria-hidden": "true"
                            }, null, 2)
                          ], 2),
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(item.title), 1),
                            _createElementVNode("span", null, _toDisplayString(item.meta), 1)
                          ]),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.money(item.amount))), 1)
                        ], 42, _hoisted_113))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_114, _hoisted_118))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedPeriod)
      ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
          _createElementVNode("div", {
            class: "category-detail__backdrop",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.closePeriodDetails && _ctx.closePeriodDetails(...args)))
          }),
          _createElementVNode("section", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _hoisted_122,
              _createElementVNode("header", _hoisted_123, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.periodDetailEyebrow), 1),
                  _createElementVNode("h2", _hoisted_125, _toDisplayString(_ctx.selectedPeriod.title), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Fechar detalhes do período",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closePeriodDetails && _ctx.closePeriodDetails(...args)))
                }, _hoisted_127)
              ])
            ]),
            _createElementVNode("div", _hoisted_128, [
              _hoisted_129,
              _createElementVNode("div", null, [
                _hoisted_130,
                _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.money(_ctx.selectedPeriod.total))), 1)
              ])
            ]),
            (_ctx.periodDetailLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_131, _hoisted_134))
              : (_ctx.periodDetailError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.periodDetailError), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.reloadPeriodDetails && _ctx.reloadPeriodDetails(...args)))
                    }, "Tentar novamente")
                  ]))
                : (_ctx.periodDetailItems.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodDetailItems, (item) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: item.key,
                          class: _normalizeClass(["category-detail__item", { 'is-clickable': item.transaction }]),
                          role: item.transaction ? 'button' : undefined,
                          tabindex: item.transaction ? 0 : undefined,
                          onClick: ($event: any) => (_ctx.openTransactionDetails(item)),
                          onKeydown: [
                            _withKeys(($event: any) => (_ctx.openTransactionDetails(item)), ["enter"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.openTransactionDetails(item)), ["prevent"]), ["space"])
                          ]
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["category-detail__icon", `is-${item.kind}`])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(item.kind === 'fixed' ? 'ph ph-calendar-check' : 'ph ph-arrow-up-right'),
                              "aria-hidden": "true"
                            }, null, 2)
                          ], 2),
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(item.title), 1),
                            _createElementVNode("span", null, _toDisplayString(item.meta), 1)
                          ]),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.money(item.amount))), 1)
                        ], 42, _hoisted_137))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_138, _hoisted_142))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedTransaction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
          _createElementVNode("div", {
            class: "transaction-detail__backdrop",
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.closeTransactionDetails && _ctx.closeTransactionDetails(...args)))
          }),
          _createElementVNode("section", _hoisted_144, [
            _createElementVNode("div", _hoisted_145, [
              _hoisted_146,
              _createElementVNode("header", _hoisted_147, [
                _hoisted_148,
                _createElementVNode("div", _hoisted_149, [
                  (!_ctx.detailEditing && _ctx.selectedTransaction.can_edit !== false)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "transaction-detail__edit-button",
                        type: "button",
                        title: "Editar lançamento",
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.startTransactionEdit && _ctx.startTransactionEdit(...args)))
                      }, _hoisted_152))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "Fechar detalhes do lançamento",
                    onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.closeTransactionDetails && _ctx.closeTransactionDetails(...args)))
                  }, _hoisted_154)
                ])
              ])
            ]),
            (_ctx.detailEditing)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "transaction-detail__edit-form",
                  onSubmit: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveTransactionEdit && _ctx.saveTransactionEdit(...args)), ["prevent"]))
                }, [
                  _createElementVNode("label", _hoisted_155, [
                    _hoisted_156,
                    _createElementVNode("div", null, [
                      _hoisted_157,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.detailAmountInput) = $event)),
                        type: "text",
                        inputmode: "numeric",
                        autocomplete: "off",
                        placeholder: "0,00",
                        "aria-label": "Valor do lançamento",
                        required: "",
                        onInput: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.sanitizeDetailAmountInput && _ctx.sanitizeDetailAmountInput(...args))),
                        onPaste: _cache[28] || (_cache[28] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDetailAmountPaste && _ctx.handleDetailAmountPaste(...args)), ["prevent"]))
                      }, null, 544), [
                        [_vModelText, _ctx.detailAmountInput]
                      ])
                    ])
                  ]),
                  (_ctx.selectedTransaction.type === 'expense')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_158, [
                        _hoisted_159,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.detailForm.category_id) = $event)),
                          class: "form-select"
                        }, [
                          _hoisted_160,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.financeCategories, (category) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: category.id,
                              value: category.id
                            }, _toDisplayString(category.name), 9, _hoisted_161))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.detailForm.category_id]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("label", _hoisted_162, [
                    _hoisted_163,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.detailForm.description) = $event)),
                      class: "form-control",
                      rows: "3",
                      maxlength: "255",
                      placeholder: "Descreva este lançamento"
                    }, null, 512), [
                      [_vModelText, _ctx.detailForm.description]
                    ])
                  ]),
                  _createElementVNode("dl", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _hoisted_166,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.formatDetailDate(_ctx.selectedTransaction.occurred_at)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_167, [
                      _hoisted_168,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.sourceLabel(_ctx.selectedTransaction.source)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_169, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: _ctx.detailSaving,
                      onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.cancelTransactionEdit && _ctx.cancelTransactionEdit(...args)))
                    }, "Cancelar", 8, _hoisted_170),
                    _createElementVNode("button", {
                      class: "is-primary",
                      type: "submit",
                      disabled: _ctx.detailSaving
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.detailSaving ? 'Salvando...' : 'Salvar alterações'), 1),
                      (!_ctx.detailSaving)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_172))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_171)
                  ]),
                  (_ctx.detailFeedback)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_173, _toDisplayString(_ctx.detailFeedback), 1))
                    : _createCommentVNode("", true)
                ], 32))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["transaction-detail__amount", `is-${_ctx.selectedTransaction.type || 'expense'}`])
                  }, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(_ctx.transactionDetailIconStyle(_ctx.selectedTransaction))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.selectedTransaction.type === 'income' ? 'ph ph-arrow-down-left' : 'ph ph-arrow-up-right'),
                        "aria-hidden": "true"
                      }, null, 2)
                    ], 4),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.selectedTransaction.type === 'income' ? 'Entrada' : 'Gasto'), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(`${_ctx.selectedTransaction.type === 'income' ? '+' : '-'}${_ctx.money(_ctx.selectedTransaction.amount)}`)), 1)
                    ])
                  ], 2),
                  _createElementVNode("dl", _hoisted_174, [
                    _createElementVNode("div", null, [
                      _hoisted_175,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.selectedTransaction.description?.trim() || 'Sem descrição'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_176,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.selectedTransaction.type === 'income' ? 'Não se aplica' : (_ctx.selectedTransaction.category?.name || 'Sem categoria')), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_177,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.formatDetailDate(_ctx.selectedTransaction.occurred_at)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_178,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.sourceLabel(_ctx.selectedTransaction.source)), 1)
                    ])
                  ])
                ], 64)),
            _createElementVNode("div", {
              class: _normalizeClass(["transaction-detail__message", { 'is-empty': !_ctx.selectedTransaction.raw_message }])
            }, [
              _hoisted_179,
              (_ctx.selectedTransaction.raw_message)
                ? (_openBlock(), _createElementBlock("blockquote", _hoisted_180, "“" + _toDisplayString(_ctx.selectedTransaction.raw_message) + "”", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_181, "Este lançamento foi registrado manualmente, sem uma mensagem original."))
            ], 2),
            (_ctx.selectedTransaction.is_recurring)
              ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                  _hoisted_183,
                  _createTextVNode(" Lançamento recorrente ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}